<template>
    <v-row align="center"
           justify="center">
        <v-col sm="7" class="pa-5">
            <h1>Impressum</h1>
            <br>
            {{contact.name}}
            <br>{{contact.street}}
            <br>{{contact.city}}<br>
            <br>Telefon: <span class="reverse"><a target="_blank" :href="contact.fonLink">{{contact.fon}}</a></span>
            <br>E-Mail: <span class="reverse"><a target="_blank"
                                                 :href="contact.mailLink">{{contact.mail}}</a></span><br>
            <br>
            <h2>Disclaimer – rechtliche Hinweise</h2><br>
            § 1 Warnhinweis zu Inhalten<br>
            Die kostenlosen und frei zugänglichen Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt erstellt.
            <br>Der Anbieter dieser Webseite übernimmt jedoch keine Gewähr für die Richtigkeit und Aktualität der
            bereitgestellten kostenlosen und frei zugänglichen journalistischen Ratgeber und Nachrichten.
            <br>Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung
            des Anbieters wieder.
            <br>Allein durch den Aufruf der kostenlosen und frei zugänglichen Inhalte kommt keinerlei Vertragsverhältnis
            zwischen dem Nutzer und dem Anbieter zustande, insoweit fehlt es am Rechtsbindungswillen des Anbieters.<br>
            <br>
            § 2 Externe Links<br>
            Diese Website enthält Verknüpfungen zu Websites Dritter ("externe Links").
            <br>Diese Websites unterliegen der Haftung der jeweiligen Betreiber.
            <br>Der Anbieter hat bei der erstmaligen Verknüpfung der externen Links die fremden Inhalte daraufhin
            überprüft, ob etwaige Rechtsverstöße bestehen.
            <br>Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich.
            <br>Der Anbieter hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der
            verknüpften Seiten.
            <br>Das Setzen von externen Links bedeutet nicht, dass sich der Anbieter die hinter dem Verweis oder Link
            liegenden Inhalte zu Eigen macht.
            <br>Eine ständige Kontrolle der externen Links ist für den Anbieter ohne konkrete Hinweise auf
            Rechtsverstöße nicht zumutbar.
            <br>Bei Kenntnis von Rechtsverstößen werden jedoch derartige externe Links unverzüglich gelöscht.<br>
            <br>
            § 3 Urheber- und Leistungsschutzrechte<br>
            Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und Leistungsschutzrecht.
            <br>Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen
            schriftlichen Zustimmung des Anbieters oder jeweiligen Rechteinhabers.
            <br>Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw.
            Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen.
            <br>Inhalte und Rechte Dritter sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder
            Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht gestattet und strafbar.
            <br>Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und nicht
            kommerziellen Gebrauch ist erlaubt.<br>
            <br>
            Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.<br>
            <br>
            § 4 Besondere Nutzungsbedingungen<br>
            Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Paragraphen
            abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen.
            <br>In diesem Falle gelten im jeweiligen Einzelfall die besonderen Nutzungsbedingungen.<br>
            <br>Quelle: <a target="_blank" href="https://www.juraforum.de/impressum-generator/">Impressum Generator von
            JuraForum.de</a>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "Impressum",
        props: {
            contactData: {
                type: Object
            }
        },
        data: function () {
            return {
                contact: this.contactData
            }
        }
    }
</script>

<style>

    span.reverse {
        unicode-bidi: bidi-override;
        direction: rtl;
    }

    .page--impressum {
        background-color: #263238;
        background-image: url('~@/assets/bg/impressum.png');
        background-position: center center;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }
</style>
